import "core-js/modules/esnext.string.replace-all.js";
export var getServerURL = function getServerURL() {
  // Returns the backend server URL, always with a slash at the end
  var url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL || '';

  if (!url.endsWith('/')) {
    url += '/';
  }

  return url;
};
export var getBusinessEmailServiceURL = function getBusinessEmailServiceURL(businessType, businessId) {
  return getServerURL() + "businesses/" + businessType + "s/" + businessId + "/email/";
};
export var cleanDomainName = function cleanDomainName(potentialDomain) {
  var sideHyphensRegex = /(^-+|-+$)/g;
  var consecutiveHyphens = /-+/g;
  var invalidChars = /[^a-zA-Z0-9-]/g;
  return potentialDomain.split('.').map(function (s) {
    return s.replaceAll(sideHyphensRegex, '').replaceAll(consecutiveHyphens, '-').replaceAll(invalidChars, '');
  }).join('.').toLowerCase();
};
export function extractMainHostnameFromDomain(domain) {
  var mainHostname = '';

  try {
    var url = new URL(domain);
    var domainParts = url.hostname.split('.'); // url like: facebook.com

    if (domainParts.length === 2) {
      mainHostname = domainParts[0];
    } // url like: www.facebook.com


    if (domainParts.length === 3) {
      mainHostname = domainParts[1];
    } // domains with root other than .com or with subdomains are not processed

  } catch (e) {// leave empty mainHostname
  }

  return mainHostname;
}